var exports = {
  "wm": "x112a1f60--62d767--logo",
  "_8": "x112a1f60--62d767--img",
  "DD": "x112a1f60--62d767--title",
  "cL": "x112a1f60--62d767--builder",
};

module.exports = exports;
